import script from "./DashboardCoach.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardCoach.vue?vue&type=script&setup=true&lang=js"

import "./DashboardCoach.vue?vue&type=style&index=0&id=3731d3b3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3731d3b3"]])

export default __exports__